module.exports = __webpack_public_path__ + "img/department.524a30a3.png";